module.exports = __webpack_public_path__ + "static/media/logo_quangninh.b29da9ac.png";